import { Tooltip, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { JSX } from 'react/jsx-runtime';
import { TimeStamp } from '../../types/GameplayTypes';
import { friendlyDateString } from '../../util/Time';

type MetadataProps = {
	id: string;
	authorName: string;
	createdAt: TimeStamp;
	updatedAt: TimeStamp;
};

export function Metadata(props: MetadataProps): JSX.Element {
	// const theme = useTheme();
	return <Typography variant="caption" color='info'>
		{metadataString(props)}
	</Typography>;
}

/** Author name with metadata as a tooltip, displayed on hover */
export const Author: FunctionComponent<{ question: MetadataProps; }> = (props) =>
	<Tooltip title={metadataString(props.question)}>
		<span>{props.question.authorName}</span>
	</Tooltip>;

export function metadataString(props: MetadataProps): string {
	const createdDate = friendlyDateString({ millis: props.createdAt });
	const updatedDate = friendlyDateString({ millis: props.updatedAt });

	let text = `Created by ${props.authorName} on ${createdDate}.`;
	if (props.createdAt !== props.updatedAt) {
		text += ` Last updated on ${updatedDate}.`;
	}
	text += ` Id: ${props.id}.`;

	return text;
}
